import React from 'react'
import cx from 'classnames'
import CloseIcon from '@material-ui/icons/Close'
import { IconButton } from '@workboard/wobo-ui'

import Box from './box'
import Flex from './flex'
import Overlay from './overlay'

import useOnOutsideClick from '../../hooks/use-on-outside-click'

import './ui.scss'

const Modal = ({
  className,
  children,
  variant,
  excludeOverlay,
  onClickOutside = () => null,
}) => {
  const ref = useOnOutsideClick(onClickOutside)

  const classes = cx(className, 'm-modal', {
    'm-modal--wide': variant === 'wide',
  })

  return (
    <>
      { !excludeOverlay &&
        <Overlay /> }

      <Flex className="m-modal__container">
        <Box className={classes} ref={ref}>
          {children}
        </Box>
      </Flex>
    </>
  )
}

Modal.Header = ({ children }) => (
  <Flex className="m-modal__header">
    {children}
  </Flex>
)

Modal.Body = ({ children }) => (
  <Box className="m-modal__body">
    {children}
  </Box>
)

Modal.Footer = ({ children }) => (
  <Flex className="m-modal__footer">
    {children}
  </Flex>
)

Modal.Close = ({ onClick }) => (
  <IconButton
    className="m-modal__close"
    onClick={onClick}
  >
    <CloseIcon />
  </IconButton>
)

export default Modal
